import { RcFile } from 'antd/lib/upload';

export const setFileUploadedToBase64 = (
  file: RcFile,
  callback: (readerResult: string | ArrayBuffer | null) => void,
) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(file);
};
